import React from 'react'
import { useGetReportsByAgencyId } from '../../../../api/agencies/useGetReportsByAgencyId'
import { Outlet, useNavigate, useParams } from 'react-router'
import AgencyReportPath from './AgencyReportPath'
import { Button, LoadingComponent } from '@demandlocal/components'

export default function AgencyReports(): JSX.Element {
  const { agency_id } = useParams()
  const { data: { data } = {}, isLoading } = useGetReportsByAgencyId({
    agency_id: Number(agency_id),
  })
  const navigate = useNavigate()
  return (
    <div className={'flex flex-1 flex-col pb-8'}>
      <div className={'pb-4 flex justify-between'}>
        <div className={'flex flex-row justify-between items-center w-full'}>
          <div className={'font-bold text-base text-primary-xiketic'}>Reports list</div>
          <Button variant="rainbow" onClick={() => navigate('generate')}>
            Generate reports
          </Button>
        </div>
      </div>
      <div className={'flex flex-1 flex-col gap-2 relative overflow-hidden'}>
        {isLoading && <LoadingComponent title={'Loading reports ...'} />}
        {!isLoading && data?.length === 0 && (
          <div className={'flex flex-1 flex-col items-center justify-center'}>
            <div className={'text-base font-bold text-primary-xiketic'}>
              No reports found...
            </div>
          </div>
        )}
        {data?.map((el) => {
          return <AgencyReportPath key={el.raw_path} pathElement={el} rootFolder={true} />
        })}
      </div>
      <Outlet />
    </div>
  )
}
